module.exports = __webpack_public_path__ + "static/img/new_baner.2deb674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_baner.jpg
// module id = 4q0K
// module chunks = 17